import { apiRequest } from '@/api/client';
import type { BulkRunSummary, BulkRunView, CreateBulkRunRequest } from '@/types/api';

/** One action on many sites (ADR-0046). */
export const bulkApi = {
  list: () => apiRequest<BulkRunSummary[]>('/bulk-runs'),
  get: (id: string) => apiRequest<BulkRunView>(`/bulk-runs/${id}`),
  create: (input: CreateBulkRunRequest) => apiRequest<BulkRunView>('/bulk-runs', { method: 'POST', body: input }),
  stop: (id: string) => apiRequest<BulkRunView>(`/bulk-runs/${id}/stop`, { method: 'POST', body: {} }),
  retry: (id: string) => apiRequest<BulkRunView>(`/bulk-runs/${id}/retry`, { method: 'POST', body: {} }),
};
